import { Button, Col, Form, Row, Spinner } from "react-bootstrap";

const GeneralExpenseForm = ({
  form,
  validationErrors,
  submitting,
  isEditMode,
  onSubmit,
  onFieldChange,
  onReset,
}) => {
  return (
    <Form onSubmit={onSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Expense Type</Form.Label>
            <Form.Control
              type="text"
              value={form.expenseType}
              onChange={(e) => onFieldChange("expenseType", e.target.value)}
              placeholder="Fuel"
              isInvalid={!!validationErrors.expenseType}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.expenseType}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={form.amount}
              onChange={(e) => onFieldChange("amount", e.target.value)}
              placeholder="1000"
              isInvalid={!!validationErrors.amount}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.amount}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={form.description}
              onChange={(e) => onFieldChange("description", e.target.value)}
              placeholder="Optional expense description"
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Expense Date</Form.Label>
            <Form.Control
              type="date"
              value={form.expenseDate}
              onChange={(e) => onFieldChange("expenseDate", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex gap-2 mt-2">
        <Button type="submit" disabled={submitting}>
          {submitting ? (
            <>
              <Spinner as="span" animation="border" size="sm" className="me-2" />
              {isEditMode ? "Saving..." : "Creating..."}
            </>
          ) : (
            isEditMode ? "Save Changes" : "Create Expense"
          )}
        </Button>
        <Button type="button" variant="light" disabled={submitting} onClick={onReset}>
          Reset
        </Button>
      </div>
    </Form>
  );
};

export default GeneralExpenseForm;
